import AuthorizationHelper from '@auth/services/authorization.helper';

export const mainAccessControlRoutes = [
  {
    path: 'access-control-badge',
    name: 'admin-access-control-badge',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.access_control_badges],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-access-control-badge" */ '@access-control/pages/access-control-badges.vue'
      ),
  },

  {
    path: 'access-control-events',
    name: 'admin-access-control-events',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.access_control_events],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-access-control-event" */ '@access-control/pages/access-control-events.vue'
      ),
  },
  {
    path: 'accesses-report',
    name: 'admin-accesses-report',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.accesses_report],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-sales-report" */ '@access-control/pages/accesses-report-page.vue'
      ),
  },
];

export const configAccessControlRoutes = [
  {
    path: 'access-points',
    name: 'admin-access-points',
    meta: {
      layout: 'bpc-admin',
      withSidebar: true,
      permissions: [AuthorizationHelper.fixedPermissions.sidebar.access_points],
    },
    component: () =>
      import(
        /* webpackChunkName: "admin-access-point" */ '@access-control/pages/access-points-page.vue'
      ),
  },
];
